export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-300.e69c4c1c.jpg";